<script>
  import {
    systemLog,
    currentSpec,
    data,
    dataInfo,
    activeSpec,
  } from "../../editor/storage.js";
  import {
    openSystemTooltip,
    closeSystemTooltip,
  } from "../../editor/utility.js";
  import { underHypothesis } from "../../editor/exploration/exploration.js";
  import {
    AugmentationStack,
    runAugmentation,
    deleteAugmentation,
  } from "../../editor/exploration/augment.js";
  import {
    afterRender,
    showSpinnerOnArtboard,
    hideSpinnerOnArtboard,
  } from "../../editor/component/artboard.js";
  // quick edit preview
  function hypothesize(spec, aug) {
    underHypothesis.set(true);
    showSpinnerOnArtboard(spec.uid);
    spec
      .hypothesize_additional($data, $dataInfo, [aug.rule], () => {
        afterRender(spec, true);
      })
      .finally(() => {
        hideSpinnerOnArtboard(spec.uid);
        $systemLog.log({
          message: "Preview augmentation",
          artboard_uid: spec.uid,
          augmentation: aug,
        });
        underHypothesis.set(false);
      });
  }
  function dehypothesize(spec, aug) {
    underHypothesis.set(true);
    showSpinnerOnArtboard(spec.uid);
    spec
      .dehypothesize($data, $dataInfo, () => {
        afterRender(spec, true);
      })
      .finally(() => {
        hideSpinnerOnArtboard(spec.uid);
        $systemLog.log({
          message: "Close augmentation preview",
          artboard_uid: spec.uid,
          augmentation: aug,
        });
        underHypothesis.set(false);
      });
  }
  let onHypo = [];
  AugmentationStack.subscribe((stack) => {
    stack?.[$activeSpec.uid]?.forEach((_) => {
      onHypo.push(false);
    });
  });
</script>

{#if $currentSpec}
  {#if $AugmentationStack?.[$activeSpec]?.length > 0}
    <div id="quick-edit">
      <div class="mb-2">
        <h4 class="h-sub">Quick edit(s)</h4>
      </div>
      {#each $AugmentationStack[$activeSpec] as aug, ai}
        <div class="augmentation-button-wrap">
          <div class="name">
            <i class="bi bi-lightning-charge-fill me-1" />{aug.name}
          </div>
          <div class="buttons">
            <button
              type="button"
              class="run"
              on:mouseover={(event) => {
                openSystemTooltip(
                  event,
                  `Click to ${onHypo[ai] ? "turn off" : "turn on"} preview`
                );
              }}
              on:focus={(event) => {
                openSystemTooltip(
                  event,
                  `Click to ${onHypo[ai] ? "turn off" : "turn on"} preview`
                );
              }}
              on:mouseover={(event) => {
                openSystemTooltip(
                  event,
                  `Click to ${onHypo[ai] ? "turn off" : "turn on"} preview`
                );
              }}
              on:mouseout={() => {
                closeSystemTooltip();
              }}
              on:blur={() => {
                closeSystemTooltip();
              }}
              on:click={() => {
                if (!onHypo[ai]) hypothesize($currentSpec, aug);
                else dehypothesize($currentSpec, aug);
                onHypo[ai] = !onHypo[ai];
              }}
            >
              <i
                class={`bi bi-eye${onHypo[ai] ? "-slash" : ""}-fill`}
                alt={onHypo[ai] ? "Turn off preview" : "Turn on preview"}
              />
            </button>
            <button
              type="button"
              class="run"
              on:click={() => {
                runAugmentation($currentSpec.uid, aug, ai);
                $systemLog.log({
                  message: "Run augmentation for all relevant",
                  artboard_uid: $currentSpec.uid,
                  augmentation: aug,
                });
              }}
              on:mouseover={(event) => {
                openSystemTooltip(
                  event,
                  "Apply this quick edit for all relevant artboard(s)."
                );
              }}
              on:mousemove={(event) => {
                openSystemTooltip(
                  event,
                  "Apply this quick edit for all relevant artboard(s)."
                );
              }}
              on:focus={(event) => {
                openSystemTooltip(
                  event,
                  "Apply this quick edit for all relevant artboard(s)."
                );
              }}
              on:mouseout={() => {
                closeSystemTooltip();
              }}
              on:blur={() => {
                closeSystemTooltip();
              }}
            >
              <i class="bi bi-reply-all-fill" alt="apply for all relevant" />
            </button>
            <button
              type="button"
              class="run"
              on:click={() => {
                aug.scope = [$currentSpec.uid];
                runAugmentation($currentSpec.uid, aug, ai);
                $systemLog.log({
                  message: "Run augmentation only for this",
                  artboard_uid: $currentSpec.uid,
                  augmentation: aug,
                });
              }}
              on:mouseover={(event) => {
                openSystemTooltip(
                  event,
                  "Apply this quick edit only for this artboard."
                );
              }}
              on:mousemove={(event) => {
                openSystemTooltip(
                  event,
                  "Apply this quick edit only for this artboard."
                );
              }}
              on:focus={(event) => {
                openSystemTooltip(
                  event,
                  "Apply this quick edit only for this artboard."
                );
              }}
              on:mouseout={() => {
                closeSystemTooltip();
              }}
              on:blur={() => {
                closeSystemTooltip();
              }}
            >
              <i class="bi bi-reply" alt="apply only for this" />
            </button>
            <button
              type="button"
              class="delete"
              on:click={() => {
                deleteAugmentation($currentSpec.uid, ai);
                dehypothesize($currentSpec, aug);
                $systemLog.log({
                  message: "Delete augmentation",
                  artboard_uid: $currentSpec.uid,
                  augmentation: aug,
                });
              }}
              on:mouseover={(event) => {
                openSystemTooltip(event, "Delete this quick edit.");
              }}
              on:mousemove={(event) => {
                openSystemTooltip(event, "Delete this quick edit.");
              }}
              on:focus={(event) => {
                openSystemTooltip(event, "Delete this quick edit.");
              }}
              on:mouseout={() => {
                closeSystemTooltip();
              }}
              on:blur={() => {
                closeSystemTooltip();
              }}
            >
              <i class="bi bi-x-lg" alt="delete this quick edit" />
            </button>
          </div>
        </div>
      {/each}
    </div>
  {/if}
{/if}

<style>
  #quick-edit {
    position: fixed;
    top: 2rem;
    right: 0;
    width: 260px;
    height: auto;
    z-index: 2999;
    padding: 1rem;
    background: rgba(0, 0, 0, 0.05);
    backdrop-filter: blur(5px);
    border-radius: 0 0 0 0.5rem;
  }
  .augmentation-button-wrap {
    border-radius: var(--default-radius);
    border: 0;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.1), 0 7px 25px rgba(0, 0, 0, 0.1);
    margin-bottom: 0.5rem;
    background-color: #eeeeee;
    overflow: hidden;
    padding: 0;
  }
  .augmentation-button-wrap:hover {
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.1), 0 7px 25px rgba(0, 0, 0, 0.1),
      0 15px 35px rgba(0, 0, 0, 0.1);
  }
  .augmentation-button-wrap .buttons {
    width: 100%;
    display: flex;
    justify-content: stretch;
  }
  .augmentation-button-wrap button {
    appearance: none;
    width: 25%;
    padding: 0.5rem 0.2rem;
    color: #454545;
    font-size: 0.75rem;
    border: 0;
    background: transparent;
    text-align: center;
    display: block;
  }
  .augmentation-button-wrap button:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
  .augmentation-button-wrap .name {
    padding: 0.5rem 1rem;
    width: auto;
    text-align: left;
    text-overflow: ellipsis;
    font-size: 0.85rem;
    border-bottom: 1px solid #ccc;
  }
</style>
